import { UndefinedContent, type XYChartState } from '../types/state.js';

export function reduceZoomDomain(
  domain: XYChartState['currentDomain'],
  zoomInEnabled: boolean,
  zoomOutEnabled: boolean,
) {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    currentDomain: domain,
    highlightedSeriesIds: undefined,
    explore: { pinned: false, visible: false, content: UndefinedContent },
    zoom: {
      ...prev.zoom,
      zoomInEnabled,
      zoomOutEnabled,
    },
    select: undefined,
  });
}
